// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { ACCOUNT_SETTINGS_ROUTE, IAM_ROUTE } from '../utilities';

export interface AllowedRoutes {
  [route: string]: boolean;
}
export interface PermissionsState {
  routes: AllowedRoutes;
}

const initialState: PermissionsState = {
  routes: {
    [ACCOUNT_SETTINGS_ROUTE]: true,
    [IAM_ROUTE]: true
  }
};

export function permissionsReducer(
  state: Readonly<PermissionsState> = initialState,
  action: any
): Readonly<PermissionsState> {
  return state;
}

export function canAccessRoute(route: string): (state: PermissionsState) => boolean {
  return (state: PermissionsState) => state.routes[route];
}

export function getAllowedRoutes(state: PermissionsState) {
  return state.routes;
}



// WEBPACK FOOTER //
// ./src/app/core/state/permissions.reducer.ts